import Resource from './Resource'

class ProvinceResource extends Resource {
    async index(couId) {
        const response = await this.axios.get(`/countries/${couId}/provinces/index`)
        return response.data
    }
}

export default new ProvinceResource()
